<div class="e-card view-card">
  <!-- Header -->
  <div class="detail-header">
    <div class="detail-header-left">
      <button type="button" class="e-btn e-flat" (click)="goBack()">
        <span class="ti ti-arrow-left icon-md"></span>
      </button>
      <div class="breadcrumb">
        <a routerLink="/notifications" class="breadcrumb-link">{{
          "notifications" | translate
        }}</a>
        <span class="breadcrumb-separator">›</span>
        <a routerLink="/notifications/sms-queue" class="breadcrumb-link">{{
          "smsQueue" | translate
        }}</a>
        <span class="breadcrumb-separator">›</span>
        <span class="breadcrumb-current">{{ "smsDetail" | translate }}</span>
      </div>
    </div>
  </div>

  @if (isLoading()) {
    <div class="loading-state">
      <span class="ti ti-loader-2 spinning icon-xl"></span>
      <span>{{ "loading" | translate }}</span>
    </div>
  }

  @if (!isLoading() && sms()) {
    <div class="detail-body">
      <!-- Status Banner -->
      <div
        class="status-banner"
        [style.background-color]="smsStatus()?.bgColor || '#f0f0f0'"
        [style.color]="smsStatus()?.fgColor || '#333'"
      >
        <span class="banner-subject">{{
          smsStatus()?.name || sms()!.status
        }}</span>
      </div>

      <!-- Info Grid -->
      <div class="info-grid">
        <div class="info-section">
          <h4 class="section-title">{{ "smsInfo" | translate }}</h4>

          <div class="info-row">
            <span class="info-label">{{ "id" | translate }}</span>
            <span class="info-value mono">{{ sms()!.id }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ "recipientPhone" | translate }}</span>
            <span class="info-value">{{ sms()!.recipientPhone }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ "retryCount" | translate }}</span>
            <span class="info-value">{{ sms()!.retryCount }}</span>
          </div>
          @if (sms()!.tenantId) {
            <div class="info-row">
              <span class="info-label">{{ "tenantId" | translate }}</span>
              <span class="info-value mono">{{ sms()!.tenantId }}</span>
            </div>
          }
        </div>

        <div class="info-section">
          <h4 class="section-title">{{ "timeline" | translate }}</h4>

          <div class="info-row">
            <span class="info-label">{{ "createdAt" | translate }}</span>
            <span class="info-value">{{
              sms()!.createdAt | date: "medium"
            }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ "sendItOn" | translate }}</span>
            <span class="info-value">{{
              sms()!.sendItOn | date: "medium"
            }}</span>
          </div>
          @if (sms()!.sentAt) {
            <div class="info-row">
              <span class="info-label">{{ "sentAt" | translate }}</span>
              <span class="info-value success-text">{{
                sms()!.sentAt | date: "medium"
              }}</span>
            </div>
          }
          @if (sms()!.updatedAt) {
            <div class="info-row">
              <span class="info-label">{{ "updatedAt" | translate }}</span>
              <span class="info-value">{{
                sms()!.updatedAt | date: "medium"
              }}</span>
            </div>
          }
        </div>
      </div>

      <!-- Failure reason -->
      @if (sms()!.failureReason) {
        <div class="code-section">
          <h4 class="section-title error-title">
            <span class="ti ti-alert-circle"></span>
            {{ "failureReason" | translate }}
          </h4>
          <div class="error-message">{{ sms()!.failureReason }}</div>
        </div>
      }

      <!-- Message content -->
      <div class="code-section">
        <h4 class="section-title">
          <span class="ti ti-message"></span>
          {{ "messageContent" | translate }}
        </h4>
        <pre class="code-block">{{ sms()!.messageContent }}</pre>
      </div>

      <!-- Recipient -->
      @if (sms()!.recipient && (sms()!.recipient | json) !== "{}") {
        <div class="code-section">
          <h4 class="section-title">
            <span class="ti ti-user"></span>
            {{ "recipient" | translate }}
          </h4>
          <pre class="code-block">{{ formatJson(sms()!.recipient) }}</pre>
        </div>
      }

      <!-- Metadata -->
      @if (sms()!.metadata && (sms()!.metadata | json) !== "{}") {
        <div class="code-section">
          <h4 class="section-title">
            <span class="ti ti-braces"></span>
            {{ "metadata" | translate }}
          </h4>
          <pre class="code-block">{{ formatJson(sms()!.metadata) }}</pre>
        </div>
      }
    </div>
  }

  @if (!isLoading() && !sms()) {
    <div class="empty-state">
      <span class="ti ti-mood-sad icon-xl"></span>
      <p>{{ "smsNotFound" | translate }}</p>
      <button type="button" class="e-btn e-primary" (click)="goBack()">
        {{ "backToList" | translate }}
      </button>
    </div>
  }
</div>
